import { LayoutComponent } from "../../../components"
import { Outlet } from "react-router-dom"

export const DevBoostLayout = () => {
    return (
        <LayoutComponent selectedMenuItem={"dev-boost"}>
            <Outlet />
        </LayoutComponent>
    )
}